import { forwardRef } from 'react';
import { isLearnTest } from '@/lib/utils';
import ChristmasConfetti from './ChristmasConfetti';
import NormalConfetti from './Normal';

export interface ConfettiRef {
  fire: () => void;
}

interface ConfettiProps {
  initial?: boolean;
}

const Confetti = forwardRef<ConfettiRef, ConfettiProps>((props, ref) => {
  const { initial = false } = props;
  return <NormalConfetti ref={ref} initial={initial} />;
});

Confetti.displayName = 'Confetti';
export default Confetti;
